/* ============================================================
   STATUS CIRI PERCUMA PRO STUDIO — bacaan hidup
   ============================================================
   Satu hook untuk SEMUA skrin yang menjaga ciri PRO Studio
   (halaman PRO Studio, popup claim, Control Panel CTA, "/" di
   Workspace, Settings → My Plan) — supaya claim di satu tempat
   terus membuka ciri di tempat lain tanpa refresh.

   Membaca `users/{uid}` — App.jsx sudah melanggan doc yang sama;
   SDK Firestore berkongsi satu langganan, jadi tiada bacaan
   berbayar tambahan.
   ============================================================ */

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';

import { db, auth } from '../firebase';
import { getUserRole, ROLES } from '../utils/roles';
import { statusCiri } from '../utils/ciriPercuma';

export function useCiriPercuma(hidup = true) {
    const [keadaan, setKeadaan] = useState({ ciriPercuma: null, sudahMuat: false });

    useEffect(() => {
        const uid = auth.currentUser?.uid;
        if (!hidup || !uid) return undefined;
        return onSnapshot(
            doc(db, 'users', uid),
            (snap) => setKeadaan({ ciriPercuma: snap.data()?.ciriPercuma || null, sudahMuat: true }),
            (e) => {
                console.warn('[CiriPercuma] gagal baca status:', e?.message);
                setKeadaan({ ciriPercuma: null, sudahMuat: true });
            }
        );
    }, [hidup]);

    const isAdmin = getUserRole(auth.currentUser?.email) === ROLES.ADMIN;
    const status = (ciri) => statusCiri(keadaan.ciriPercuma, ciri, isAdmin);
    return { ...keadaan, isAdmin, status };
}
